import i18next from "i18next";
import { LoginFormData } from "../../models/login/loginFormData";
import { Api, IApi } from "../../utilities/Api";
import { ApiRequest } from "../../utilities/ApiRequest";
import LMSDispatcher from "../LMSDispatcher";
import * as ACTIONCONTANTS from "./ActionConstants";

class LoginActions {
  private readonly api: IApi;
  constructor() {
    this.api = new Api(ACTIONCONTANTS.AUTH_ENDPOINT);
  }
  async login(data: LoginFormData): Promise<void> {
    try {
      const request = new ApiRequest(
        "/Login/",
        "",
        data,
        i18next.t("loggedin Successfully.")
      );
      const result = await this.api.login(request);
      const payload = result.data;
      LMSDispatcher.dispatch({
        type: ACTIONCONTANTS.LOGIN_DETAILS,
        payload: {
          data: payload,
        },
      });
    } catch (error) {
      throw error;
    }
  }
  async keycloakLogin(data: LoginFormData): Promise<boolean> {
    try {
      const request = new ApiRequest(
        "/InitialKeyCloakSetup",
        "",
        data,
        i18next.t("loggedin Successfully.")
      );
      const result = await this.api.post(request);
      return result?.data;
    } catch (error) {
      throw error;
    }
  }
  async keyCloakHealthCheck(): Promise<boolean> {
    try {
      const request = new ApiRequest(
        "/HealthCheck", "", null, ""
      );
      const result = await this.api.get(request);
      return result?.data;
    } catch (error) {
      throw error;
    }
  }
  async InitialKeyCloakSetup(): Promise<boolean> {
    try {
      const request = new ApiRequest(
        "/InitialKeyCloakSetup", "", null, ""
      );
      const result = await this.api.get(request);
      return result?.data;
    } catch (error) {
      throw error;
    }
  }
  async SetInitialKeyCloakSetup(status: boolean): Promise<boolean> {
    try {
      const request = new ApiRequest(
        "/InitialKeyCloakSetup", "", status, ""
      );
      await this.api.put(request);
      return true;
    } catch (error) {
      throw error;
    }
  }
}

const loginActions = new LoginActions();
export default loginActions;
